import React from "react";
import { Link } from "react-router-dom";
import { Youtube, Instagram, Facebook, Twitter, Music2 } from "lucide-react";
import Logo from "@/components/Logo";
import { NAV_ITEMS, SOCIALS } from "@/lib/constants";

const SOCIAL_ICONS = { youtube: Youtube, instagram: Instagram, facebook: Facebook, tiktok: Music2, x: Twitter };

const LEGAL = [
  { label: "Política Editorial", path: "/quienes-somos" },
  { label: "Política de Correcciones", path: "/quienes-somos" },
  { label: "Derecho a Respuesta", path: "/contacto" },
  { label: "Privacidad", path: "/quienes-somos" },
  { label: "Términos y Condiciones", path: "/quienes-somos" },
];

export default function Footer() {
  return (
    <footer className="bg-nx-dark text-slate-300 mt-20" data-testid="site-footer">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <Logo variant="footer" />
            <p className="mt-5 text-sm leading-relaxed text-slate-400 max-w-xs">
              <span className="text-white font-semibold">Historias que nos conectan.</span><br />
              Medio de comunicación independiente dedicado al periodismo, la información y la producción de contenidos sobre sociedad, culturas, comunidades y actualidad.
            </p>
            <div className="flex items-center gap-4 mt-6">
              {SOCIALS.map((s) => {
                const Icon = SOCIAL_ICONS[s.key];
                const hasUrl = !!s.url;
                return (
                  <a key={s.key} href={hasUrl ? s.url : "#"} aria-label={s.name} data-testid={`footer-social-${s.key}`}
                    target={hasUrl ? "_blank" : undefined} rel={hasUrl ? "noopener noreferrer" : undefined}
                    onClick={(e) => { if (!hasUrl) e.preventDefault(); }}
                    className="text-slate-400 hover:text-nx-orange transition-colors">
                    <Icon size={20} strokeWidth={1.7} />
                  </a>
                );
              })}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-white font-bold text-sm tracking-widest uppercase mb-4">Secciones</h4>
            <ul className="space-y-2.5 text-sm">
              {NAV_ITEMS.filter((n) => n.label !== "QUIÉNES SOMOS").map((n) => (
                <li key={n.path}>
                  <Link to={n.path} className="text-slate-400 hover:text-white transition-colors capitalize"
                    data-testid={`footer-link-${n.path === "/" ? "inicio" : n.path.slice(1)}`}>
                    {n.label.charAt(0) + n.label.slice(1).toLowerCase()}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-white font-bold text-sm tracking-widest uppercase mb-4">Institucional</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/quienes-somos" className="text-slate-400 hover:text-white transition-colors" data-testid="footer-link-quienes">Quiénes somos</Link></li>
              <li><Link to="/contacto" className="text-slate-400 hover:text-white transition-colors" data-testid="footer-link-contacto">Contacto</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-white font-bold text-sm tracking-widest uppercase mb-4">Legales</h4>
            <ul className="space-y-2.5 text-sm">
              {LEGAL.map((l, i) => (
                <li key={i}><Link to={l.path} className="text-slate-400 hover:text-white transition-colors">{l.label}</Link></li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} NEXODUM · Medio de comunicación independiente.</p>
          <p className="text-slate-600">NEXODUM no representa a ninguna religión, iglesia, colectividad, partido político u organismo estatal.</p>
        </div>
      </div>
    </footer>
  );
}
